import {Component, HostListener, Input, OnInit} from '@angular/core';
import {UserRepresentation} from '../../models/UserRepresentation';
import {OAuthService} from '../../services/o-auth.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {LocalStorageKeys} from '../../models/enums/LocalStorageKeys';


@Component({
    selector: 'mb-user-photo',
    templateUrl: './user-photo.component.html',
    styleUrls: ['./user-photo.component.scss']
})
export class UserPhotoComponent implements OnInit {

    loading;
    userPhoto;
    firstLetter;
    secondLetter;

    @Input() width: number = 41;
    @Input() height: number = 41;
    @Input() fontSize: number = 21;
    @Input() user: UserRepresentation;

    constructor(private _oauthService: OAuthService,
                private _localStorageService: LocalStorageService) {
        this.loading = false;
    }

    ngOnInit(): void {
        this.firstLetter = this.user.firstName.substring(0, 1).toUpperCase();
        this.secondLetter = this.user.lastName.substring(0, 1).toUpperCase();
        this.userPhoto = this._localStorageService.get(LocalStorageKeys.USER_PHOTO);
        this.loadPhoto();
    }

    loadPhoto(): void {
        if(!this._localStorageService.get(LocalStorageKeys.USER_PHOTO)) {
            this.loading = true;
            this._oauthService.findUserPhoto(this.user.id).subscribe(photo => {
                this._localStorageService.set(LocalStorageKeys.USER_PHOTO, photo);
                this.userPhoto = photo;
                this.loading = false;
            });
        }
    }

    @HostListener('window:storage', ['$event'])
    storageChange(event: StorageEvent) {
        if(event.key === LocalStorageKeys.USER_PHOTO && event.newValue){
            this.userPhoto = event.newValue;
        }
    }

}